import { fetchMachineSelectOptions } from '@/api/options/machine'
import { useMachineTrackingStore } from '@/stores/rootStore'
import { useRouteContext } from '@tanstack/react-router'
import { useEffect } from 'react'

export default function HubConnection() {
  const { queryClient } = useRouteContext({ from: '/_auth' })
  const machineTrackingStore = useMachineTrackingStore()

  useEffect(() => {
    console.log('HubConnection mounted')
    // Set up an interval to update durations every minute
    const interval = setInterval(() => {
      machineTrackingStore.updateDurations()
    }, 60000)

    // Ensure the query client has the machine select options available
    queryClient
      .ensureQueryData(fetchMachineSelectOptions())
      .then((machines) => {
        // Start machine tracking service
        machineTrackingStore.startConnection(machines, queryClient)
      })

    return () => {
      console.log('HubConnection cleanup')
      clearInterval(interval)
      machineTrackingStore.stopConnection()
    }
  }, [queryClient, machineTrackingStore])

  return null
}
